import { acceptHMRUpdate, defineStore } from 'pinia'
import { HttpStatusCode } from 'axios'
import api from '@api'
import type {
  AutocompleteRequest,
  ByEmailTendersListParams,
  CarrierOfferBulkSave,
  ContractAcceptedByCarrier,
} from '@apiTypes'

export const useCarrierTendersStore = defineStore('carrierTenders', {
  actions: {
    fetchTenders(query: ByEmailTendersListParams) {
      return api.byEmail.byEmailTendersList(query)
    },
    autocomplete(data: AutocompleteRequest) {
      return api.byEmail.byEmailTendersAutocompleteCreate(data).then(response => response.data.values)
    },
    fetchTender(hash: string) {
      return api.byEmail.byEmailTendersRetrieve({ hash })
    },
    fetchRoutes(hash: string) {
      return api.byEmail.carrierTendersRoutesRetrieve({ hash })
    },
    fetchCategories(hash: string) {
      return api.byEmail.carrierTendersCategoriesRetrieve({ hash })
    },
    fetchPriceOffers(hash: string) {
      return api.byEmail.carrierTendersOffersRetrieve({ hash })
    },
    savePriceOffersDraft(hash: string, data: CarrierOfferBulkSave): Promise<void> {
      return api.byEmail
        .byEmailTendersSavePricesCreate({ hash }, data)
        .then(() => undefined)
    },
    submitPriceOffers(hash: string, data: CarrierOfferBulkSave): Promise<void> {
      return api.byEmail
        .byEmailTendersSubmitPricesCreate({ hash }, data)
        .then(() => undefined)
    },
    fetchHistoryOffers(hash: string) {
      return api.byEmail.carrierTendersHistoryOffersRetrieve({ hash })
    },
    fetchContractProposal(hash: string) {
      return api.byEmail.carrierTendersContractProposalRetrieve({ hash })
        .then(response => ({ ...response, data: response.status === HttpStatusCode.NoContent ? null : response.data }))
    },
    fetchConfirmedContract(hash: string) {
      return api.byEmail.carrierTendersConfirmedContractRetrieve({ hash })
        .then(response => ({ ...response, data: response.status === HttpStatusCode.NoContent ? null : response.data }))
    },
    acceptContractProposal(hash: string): Promise<ContractAcceptedByCarrier> {
      return api.byEmail
        .carrierTendersProposalAccept({ hash })
        .then(response => response.data)
    },
    rejectContractProposal(hash: string): Promise<void> {
      return api.byEmail
        .carrierTendersProposalReject({ hash })
        .then(() => undefined)
    },
  },
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useCarrierTendersStore, import.meta.hot))
